import LoginContainer from './login-container';
import {ReactRoute} from '../../utils/router-utils';

export default ReactRoute({
    path: '/login',
    exact: true,
    component: LoginContainer,
    routes: []
});



// WEBPACK FOOTER //
// ./src/js/routes/login/index.js